var React = require('react');

function Block (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.34665 7.59436C5.29359 8.94904 4.6665 10.6513 4.6665 12.5C4.6665 16.9183 8.24823 20.5 12.6665 20.5C14.5152 20.5 16.2175 19.8729 17.5721 18.8199L6.34665 7.59436ZM7.76086 6.18014L18.9864 17.4056C20.0394 16.051 20.6665 14.3487 20.6665 12.5C20.6665 8.08172 17.0848 4.5 12.6665 4.5C10.8178 4.5 9.11554 5.12708 7.76086 6.18014ZM2.6665 12.5C2.6665 6.97715 7.14366 2.5 12.6665 2.5C18.1894 2.5 22.6665 6.97715 22.6665 12.5C22.6665 18.0228 18.1894 22.5 12.6665 22.5C7.14366 22.5 2.6665 18.0228 2.6665 12.5Z"}));
}

Block.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none"};

module.exports = Block;

Block.default = Block;
